import WYSIWYG from '@components/ui/WYSIWYG'
import cn from 'clsx'

interface Props {
  slice: any
}

const Table = ({ slice }: Props) => {
  const title = slice?.primary?.title
  const equalColumnWidth = slice?.primary?.equalColumnWidth
  const column1Title = slice?.primary?.column1Title || 'Column 1'
  const column2Title = slice?.primary?.column2Title || 'Column 2'
  const column3Title = slice?.primary?.column3Title || 'Column 3'
  const columns = [
    slice?.primary?.column1Title,
    slice?.primary?.column2Title,
    slice?.primary?.column3Title,
  ].filter((column) => column !== null)
  const items = slice?.items || [
    {
      linkTextFirstCol: [
        { spans: [], text: 'Column1 Content', type: 'paragraph' },
      ],
      linkTextSecondCol: [
        { spans: [], text: 'Column2 Content', type: 'paragraph' },
      ],
      linkTextThirdCol: [
        { spans: [], text: 'Column2 Content', type: 'paragraph' },
      ],
    },
  ]

  return (
    <section className="bg-brand-light-grey py-8 lg:py-16">
      {title && <span className="heading-mobile-4 lg:heading-4">{title}</span>}
      <table
        className={cn(
          'tablet:table-fixed mt-6 w-full table-auto border-collapse border border-ui-grey-25',
          { 'equal-width-column': equalColumnWidth }
        )}
      >
        <thead>
          <tr>
            {slice?.primary?.column1Title && (
              <th
                className={cn(
                  `body-2-bold border border-ui-grey-25 bg-ui-lightest-grey py-1.5 px-2 text-left lg:py-2.5 lg:px-4`
                )}
              >
                {column1Title}
              </th>
            )}
            {slice?.primary?.column2Title && (
              <th
                className={cn(
                  `body-2-bold border border-ui-grey-25 bg-ui-lightest-grey py-1.5 px-2 text-left lg:py-2.5 lg:px-4`
                )}
              >
                {column2Title}
              </th>
            )}
            {slice?.primary?.column3Title && (
              <th
                className={cn(
                  `body-2-bold border border-ui-grey-25 bg-ui-lightest-grey py-1.5 px-2 text-left lg:py-2.5 lg:px-4`
                )}
              >
                {column3Title}
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {items?.map((item: any, index: number) => {
            return (
              <tr key={index}>
                {slice?.primary?.column1Title && (
                  <td className="body-2 border border-ui-grey-25 py-1.5 px-2 lg:py-2.5 lg:px-4">
                    {item?.linkTextFirstCol && (
                      <WYSIWYG content={item.linkTextFirstCol} />
                    )}
                  </td>
                )}
                {slice?.primary?.column2Title && (
                  <td className="body-2 border border-ui-grey-25 py-1.5 px-2 lg:py-2.5 lg:px-4">
                    {item?.linkTextSecondCol && (
                      <WYSIWYG content={item.linkTextSecondCol} />
                    )}
                  </td>
                )}
                {slice?.primary?.column3Title && (
                  <td className="body-2 border border-ui-grey-25 py-1.5 px-2 lg:py-2.5 lg:px-4">
                    {item?.linkTextThirdCol && (
                      <WYSIWYG content={item.linkTextThirdCol} />
                    )}
                  </td>
                )}
              </tr>
            )
          })}
        </tbody>
      </table>
      <style jsx>{`
        .equal-width-column th {
          width: calc(100% / ${columns.length});
        }
      `}</style>
    </section>
  )
}

export default Table
